import { FileTypes } from "@app/shared/constants/file-types.constants";
import { Adapter } from "@app/shared/models/adapter.model";
import { GuessedFile, Info } from "magic-bytes.js/dist/model/tree";

/**
 * Interface for requesting a file for downloading
 */
export interface FileDownload {
  file: string;
  type: FileTypes;
}

/**
 * Interface for retrieving downloaded file as a binary file
 */
export interface FileDownloadBinary {
  binaryFile: Blob;
  error: boolean;
  fileType: GuessedFile & Info;
}

/**
 * Interface for tracking download progress
 */
export interface FileDownloadStatus {
  status: string;
  loaded: number;
}

/**
 * Enum for file progress status
 */
export enum FileStatus {
  none = "",
  completed = "completed",
  progress = "progress",
  error = "error",
  cancel = "cancel",
  adding = "adding",
  converting = "converting",
  attach = "attach",
  uploaded = "uploaded"
}

/**
 * Interface for retreiving response after file upload
 */
export interface FileUpload {
  file: string;
  name: string;
  error: boolean;
}

/**
 * Interface for tracking upload progress
 */
export interface FileUploadProgress {
  status: FileStatus;
  progress: number;
  total?: number;
}

/**
 * Interface for retreiving response after file upload
 */
export interface FileDelete {
  fileList: string[];
}

/**
 * File Download adapter
 */
export class FileDownloadAdapter implements Adapter<FileDownloadBinary> {
  adapt(rawData: any): FileDownloadBinary {
    const data: FileDownloadBinary = {
      binaryFile: new Blob([rawData], { type: "application/binary" }),
      error: false,
      fileType: undefined
    };
    return data;
  }
}

/**
 * File upload adapter
 */
export class FileUploadAdapter implements Adapter<FileUpload> {
  adapt(rawData: any): FileUpload {
    rawData.error = false;
    return rawData;
  }
}

export class FileInputDecodeAdapter implements Adapter<FileUpload> {
  adapt(rawData: any): FileUpload {
    rawData.error = false;
    return rawData;
  }
}

/**
 * File delete adapter
 */
export class FileDeleteAdapter implements Adapter<FileDelete> {
  adapt(rawData: any): FileDelete {
    rawData.error = false;
    return rawData;
  }
}
